export const isProdEnv = process.env.STAGE === 'production'
export const isTestEnv = process.env.STAGE === 'test'
// not a perfect solution, but with current stack setup process.env.STAGE === 'dev' is not possible
export const isDevEnv = !isProdEnv && !isTestEnv
export const isLocalhost = typeof window !== 'undefined'
	&& (
		window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
	)

export const envProdOr = (production, or) => (isProdEnv ? production : or || production)
